function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M26.667 5C27.956 5 29 6.044 29 7.333v17.334C29 25.956 27.956 27 26.667 27H5.333C4.044 27 3 25.956 3 24.667V7.333C3 6.044 4.044 5 5.333 5h21.334zM12.048 15.712l-.129.083L4 22.66v2.006c0 .693.529 1.262 1.204 1.327l.129.006h7.975l-.015-.015 6.007-5.753-5.285-4.362c-.53-.439-1.386-.49-1.967-.158zm10.08 3.206l-.101.089L14.72 26h11.946c.693 0 1.262-.529 1.327-1.204l.006-.129V22.42l-4.299-3.491c-.457-.37-1.117-.369-1.573-.011zM26.668 6H5.332c-.693 0-1.262.529-1.327 1.204L4 7.333v14.004l7.296-6.323c.924-.678 2.279-.682 3.206-.03l.15.115 5.375 4.437 1.305-1.248c.772-.754 1.977-.846 2.856-.243l.143.107L28 21.13V7.333c0-.693-.529-1.262-1.204-1.327L26.667 6zM22 9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0 1c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
});

var SvgIconPhotoNone = function SvgIconPhotoNone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPhotoNone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-photo-none.e90d424e.svg";
export { ForwardRef as ReactComponent };